<template>
<v-main>
    
    <v-form ref="anexosViewFilterForm">
        <v-row class="pl-2 pr-0"> 
            <v-col class="pr-2 pb-0" cols="2">
                <label>Motivo da glosa</label>
                <v-select
                    v-model="formData.motivo_glosa"
                    :items="motivosGlosasFilter"
                    item-value="motivo_glosa"
                    item-text="descricao_motivo_glosa"
                    :menu-props="{ bottom: true, offsetY: true }"
                    flat
                    solo
                    dense
                    outlined
                ></v-select>
            </v-col>

            <v-col class="pr-2 pb-0" cols="2">
                <label>Identificação do prestador</label>
                <v-autocomplete
                    v-model="formData.identificacao_prestador"
                    :items="prestadoresFilter"
                    item-value="id"
                    item-text="descricao"
                    :menu-props="{ bottom: true, offsetY: true }"
                    flat
                    solo
                    dense
                    outlined
                ></v-autocomplete>
            </v-col>
            <v-col class="pr-2 pb-0" cols="2" v-show="formData.tipo_consulta=='itens'">
                <label>Cód. do procedimento</label>
                <v-autocomplete
                    v-model="formData.codigo_procedimento"
                    :items="procedimentosFilter"
                    item-value="id"
                    item-text="descricao"
                    :menu-props="{ bottom: true, offsetY: true }"
                    flat
                    solo
                    dense
                    outlined
                ></v-autocomplete>
            </v-col>
            <v-col class="pr-2 pb-0" cols="2">
                <label>Nº guia prestador </label> 
                  <v-text-field
                            v-model="formData.numero_guia"
                            placeholder="Nº guia prestador"
                            persistent-hint
                            outlined
                            dense
                 ></v-text-field>
            </v-col>
            <v-col class="pr-2 pb-0" cols="3" v-show="showFiltroAvancado">
                <label>Valor glosado</label>
                <v-row class="px-0 pb-0">
                    <v-col class="px-2 pb-0" cols="5">
                        <v-select
                        v-model="formData.valor_glosado_set"
                        :menu-props="{ bottom: true, offsetY: true }"
                        flat
                        solo
                        dense
                        :items="operadores"
                        item-text="descricao"
                        item-value="operador"
                        outlined
                        :rules="formData.valor_glosado && formData.valor_glosado_set == null ? formRules.required: []"
                        ></v-select>
                    </v-col>
                    <v-col class="px-0 pb-0" cols="6">
                        <v-text-field
                            v-model="format.valor_glosado"
                            placeholder="Valor a ser comparado"
                            persistent-hint
                            outlined
                            dense
                            @input="formatPrice(format, 'valor_glosado')"
                            @blur="formatPrice(format, 'valor_glosado')"
                            :rules="[formRules.typeNumber]"
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-col>
            <v-col class="pr-2 pb-0" cols="3" v-show="showFiltroAvancado">
                <label>Valor informado</label>
                <v-row class="px-0 pb-0">
                    <v-col class="pl-2 pb-0" cols="5">
                        <v-select
                        v-model="formData.valor_informado_set"  
                        :menu-props="{ bottom: true, offsetY: true }"
                        flat
                        solo
                        dense
                        :items="operadores"
                        item-text="descricao"
                        item-value="operador"
                        outlined
                        :rules="formData.valor_informado && formData.valor_informado_set == null ? formRules.required: []"
                        ></v-select>
                    </v-col>
                    <v-col class="px-0 pb-0" cols="6">
                        <v-text-field
                            v-model="format.valor_informado"
                            placeholder="Valor a ser comparado"
                            persistent-hint
                            outlined
                            dense
                            @input="formatPrice(format, 'valor_informado')"
                            @blur="formatPrice(format, 'valor_informado')"
                            :rules="[formRules.typeNumber]"
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-col>
            <v-col class="pr-2 pb-0" cols="3" v-show="showFiltroAvancado">
                <label>Pesquisar por</label>
                <v-row class="px-0 pb-0">
                    <v-col class="px-2 pb-0" cols="6">
                        <v-select
                        v-model="formData.tipoPesquisa"
                        :menu-props="{ bottom: true, offsetY: true }"
                        flat
                        solo
                        dense
                        :items="tipoPesquisaLista"
                        item-text="descricao"
                        item-value="id"
                        outlined
                        @change="formData.nota_fiscal = null; formData.protocolo = null; formData.numero_lote = null;"
                        ></v-select>
                    </v-col>
                    <v-col class="px-2 pb-0" cols="6">
                        <v-text-field
                            v-model="formData[formData.tipoPesquisa]"
                            :placeholder="labelBuscaGenerica[formData.tipoPesquisa]"
                            persistent-hint
                            outlined
                            dense
                            :disabled="!formData.tipoPesquisa"
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-col>
           
            <v-col class="pr-2 pb-0" cols="3" v-show="showFiltroAvancado && formData.tipo_consulta=='guias'">
                <label>Data de autorização</label>
                <v-menu
                    :close-on-content-click="true"
                    transition="scale-transition"
                    offset-y
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="data_autorizacao_formated"
                            dense
                            v-mask="'##/##/####'"
                            format="DD/MM/YYYY"
                            placeholder="DD/MM/YYYY"
                            label
                            outlined
                            v-bind="attrs"
                            v-on="on"
                            append-icon="mdi-calendar-blank"
                            @blur="formData.data_autorizacao = parseDate(data_autorizacao_formated)"
                        ></v-text-field>
                    </template>
                    <v-date-picker color="primary"  v-model="formData.data_autorizacao" @input="data_autorizacao_formated = formatDate(formData.data_autorizacao)" no-title scrollable></v-date-picker>
                </v-menu>
            </v-col>
            <v-col class="pr-2 pb-0" cols="2" v-show="showFiltroAvancado && formData.tipo_consulta=='itens'">
            <label>Data de execução</label>
            <v-menu
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
            >
                <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="data_execucao_formated"
                    dense
                    v-mask="'##/##/####'"
                    format="DD/MM/YYYY"
                    placeholder="DD/MM/YYYY"
                    label
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    append-icon="mdi-calendar-blank"
                    @blur="formData.data_execucao = parseDate(data_execucao_formated)"
                ></v-text-field>
                </template>
                <v-date-picker color="primary"  v-model="formData.data_execucao" @input="data_execucao_formated = formatDate(formData.data_execucao)" no-title scrollable></v-date-picker>
            </v-menu>
            </v-col>
        
        <v-col class="pr-2 pt-8 text-right" >
            <v-btn
                text
                color="primary"
                depressed
                x-small
                class="px-1 mr-2"
                height="32px"
                @click="showFiltroAvancado = !showFiltroAvancado; !showFiltroAvancado ?clearFilter(true) :null"
            ><v-icon x-small class="mr-2">{{showFiltroAvancado? 'fa-minus-circle' : 'fa-plus-circle' }}</v-icon> {{showFiltroAvancado? 'Filtro básico' : 'Filtro avançado' }}
            </v-btn>
            <v-btn small  height="32px" color="primary" class="px-2 mr-2" depressed @click="filterValid()" >Filtrar</v-btn>
            <v-btn outlined small  height="32px" color="primary" class="px-2 ml-0" depressed @click="clearFilter()" >Limpar Filtro</v-btn>
        </v-col>
    </v-row>
    <v-divider class="mx-0"></v-divider>
    </v-form>
</v-main>
</template>

<script>
import { mapActions, mapState  } from 'vuex'
const initialFormData = {
                tipo_consulta: 'guias',
                operador: null,
                motivo_glosa: null, 
                descricao_motivo_glosa: null,
                identificacao_prestador: null, 
                valor_glosado_set: null,
                valor_glosado: null, 
                valor_informado_set: null,
                valor_informado: null, 
                data_autorizacao: null, 
                data_execucao: null, 
                numero_guia: null, 
                codigo_procedimento: null,
                analisadas: false,
                estado: null,
                tipoPesquisa: null,
                nota_fiscal: null,
                numero_lote: null,
                protocolo: null,
                reapresentacao: false,
                recurso_guia_id: null
            }
export default {
    data() {
        return {
            data_autorizacao_formated: null,
            data_execucao_formated: null,
            motivosGlosasFilter: [],
            formData: {...initialFormData},
            format: {
                valor_glosado: null,
                valor_informado: null
            },
            operadores: [
                { operador: null, descricao:'selecione', tipos: ['string', 'integer', 'float', 'dominio', 'date', 'time'] },
                { operador: 1, descricao:'é igual a', tipos: ['string', 'integer', 'float', 'dominio', 'date', 'time'] },
                { operador: 2, descricao:'é maior que', tipos: ['integer', 'float', 'date', 'time'] },
                { operador: 3, descricao:'é menor que', tipos: ['integer', 'float', 'date', 'time'] }
            ],
            prestadoresFilter:[],
            procedimentosFilter: [],
            showFiltroAvancado: false,
            estadoFilter: [],
            tipoPesquisaLista: [
                {id: null, descricao: 'Selecione'},
                {id: 'nota_fiscal', descricao: 'Nota fiscal'},
                {id: 'protocolo', descricao: 'Protocolo'},
                {id: 'numero_lote', descricao: 'Nº do lote'}
            ],
            labelBuscaGenerica:{
                nota_fiscal: 'Número da nota fiscal',
                protocolo: 'Número do protocolo',
                numero_lote: 'Número do lote'
            }
        }
    },
    watch:{
        resetFilter: {
            deep: true,
            handler(val){
                if(val){
                    this.clearFilter(false);
                }
            }
        },
        tab(val){
            this.formData.tipo_consulta = val == 1? "guias" : "itens"
        },
        filterData: {
            deep: true,
            handler(val){
                this.formData = Object.assign(initialFormData, val)
                this.formData.tipo_consulta = this.tab == 1? "guias" : "itens"
            }
        },
        estadoList(val){
            this.estadoFilter = [...val]
            this.estadoFilter.unshift({id: null, descricao: "Selecione", cor: null})
        },
        prestadoresList(){
            this.prestadoresFilter = this.prestadoresList.map(el=> ({id:el.identificador_prestador, descricao:el.identificador_prestador}))
            this.prestadoresFilter.unshift({id: null, descricao: "Selecione"})
        },
        procedimentosList(){
            this.procedimentosFilter = this.procedimentosList.map(el=> ({id:el.codigo_procedimento, descricao:(el.codigo_procedimento + ' - ' + el.descricao_procedimento)}))
            this.procedimentosFilter.unshift({id: null, descricao: "Selecione"})
        },
        motivosGlosaList(){
                let val = JSON.parse(JSON.stringify(this.motivosGlosaList));
                this.motivosGlosasFilter = val.map(el=>{
                if(el.descricao_motivo_glosa == null || el.descricao_motivo_glosa == ""){
                    el.descricao_motivo_glosa = el.motivo_glosa
                } else {
                     el.descricao_motivo_glosa = el.motivo_glosa + " - "+ el.descricao_motivo_glosa
                }
                return el
            })
        this.motivosGlosasFilter.unshift({descricao_motivo_glosa: "Selecione", motivo_glosa: null})

        }
    },
    mounted() {
        this.estadoFilter = [...this.estadoList]
        this.estadoFilter.unshift({id: null, descricao: "Selecione", cor: null})
        
        this.prestadoresFilter = this.prestadoresList.map(el=> ({id:el.identificador_prestador, descricao:el.identificador_prestador}))
        this.prestadoresFilter.unshift({id: null, descricao: "Selecione"})
        
        this.procedimentosFilter = this.procedimentosList.map(el=> ({id: el.codigo_procedimento, descricao: (el.codigo_procedimento +' - '+ el.descricao_procedimento)}))
        this.procedimentosFilter.unshift({id: null, descricao: "Selecione"})
        let tipo_consulta = this.tab==1? "guias": "itens"
        this.formData = {...this.filterData, tipo_consulta}
        this.formData.valor_glosado_set = this.formData.valor_glosado_set != null ?this.formData.valor_glosado_set  :null
        this.formData.valor_informado_set = this.formData.valor_informado_set != null ?this.formData.valor_informado_set  :null
    },
    computed:{
        ...mapState({
            formRules: (state) => state.formRules,
        }),
    },
    methods: {
        ...mapActions('common', [
            "formatDate",
            "parseDate",
        ]),
        clearFilter(filtroBasico){
            
            this.$refs.anexosViewFilterForm.resetValidation()
            this.formData.motivo_glosa = filtroBasico 
            ?this.formData.motivo_glosa :null
            this.formData.identificacao_prestador = filtroBasico 
            ?this.formData.identificacao_prestador :null
            this.format.valor_glosado = null 
            this.formData.valor_glosado_set = null
            this.formData.valor_glosado = null
            this.format.valor_informado = null
            this.formData.valor_informado_set = null
            this.formData.valor_informado = null
            this.data_autorizacao_formated = null
            this.formData.data_autorizacao = null
            this.data_execucao_formated = null
            this.formData.data_execucao = null
            this.formData.numero_guia = null
            this.formData.codigo_procedimento = null //Item
            this.formData.estado = null
            this.formData.analisadas = this.filterData? this.filterData.analisadas : false,
            this.formData.nota_fiscal = null,
            this.formData.numero_lote = null,
            this.formData.protocolo = null,
            this.formData.tipoPesquisa = null,
            this.formData.recurso_guia_id = null,
            this.filterList(this.formData)
        },
        updateListFilter(filterName, ListName, selecioneObj){
            this[filterName] = [...this[ListName]]
            this[filterName].unshift(selecioneObj)
        },
        formatPrice(item, param) {
            this.$refs.anexosViewFilterForm.validate()
            let value = item[param] != null ?item[param].replaceAll(/(!\d|\.|,)/g, '') :''
            value = value.toString().replace(/\B(?=(\d{2})(?!\d))/g, ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            this.formData[param] = Number(value.replace(/[^\d]+/g,'').replace(/\B(?=(\d{2})(?!\d))/g, "."))
            item[param] = value
        },
        formatDate(date) {
            if (!date) return null;
            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },
        parseDate(date) {
            if (!date) return null;
            const [day, month, year] = date.split("/");
            return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
        },
        selectEstado(val) {
            if (!!val && val != 4)
                this.formData.analisadas = true
            else if(val == 4) {
                this.formData.analisadas = false
            }
        },
        filterValid() {
            if (this.$refs.anexosViewFilterForm.validate()) {
                this.filterList(this.tab, 1, this.formData)
            }
        }
    },
    props: {
        filterList: Function,
        filterData: Object,
        motivosGlosaList: Array,
        prestadoresList: Array,
        procedimentosList: Array,
        estadoList: Array,
        tipo_pagamento: Number,
        concluirRecurso: Function,
        dadosPagamento: Object,
        listaNumGuias: Array,
        tab: Number,
        resetFilter: Boolean
    }
}
</script>

<style>

</style>